export const CreateQuoteSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 3.75V14.25M3.75 9H14.25"
      stroke="#101828"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoTaskCreatedIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3953 17.0534L12.9991 15.7023L11.6029 17.0534C10.8333 17.7982 9.58023 17.7982 8.81061 17.0534C8.04099 16.3086 8.04099 15.1007 8.81061 14.3511L10.2068 13L8.81061 11.6489C8.04099 10.9041 8.04099 9.6914 8.81061 8.94661C9.58023 8.20182 10.8333 8.20182 11.6029 8.94661L12.9991 10.2977L14.3953 8.94661C15.1649 8.20182 16.4131 8.20182 17.1876 8.94661C17.9572 9.6914 17.9572 10.9041 17.1876 11.6489L15.7914 13L17.1876 14.3511C17.9572 15.0959 17.9572 16.3038 17.1876 17.0534C16.4131 17.7982 15.1649 17.7982 14.3953 17.0534ZM13.3494 14.6901L15.0958 16.3802C15.4806 16.7526 16.1072 16.7526 16.492 16.3802C16.8768 16.0078 16.8768 15.4015 16.492 15.0291L14.7456 13.339C14.5531 13.1528 14.5531 12.852 14.7456 12.6658L16.492 10.9757C16.8768 10.6033 16.8768 9.99696 16.492 9.62456C16.1072 9.25217 15.4806 9.25217 15.0958 9.62456L13.3494 11.3147C13.157 11.5009 12.8462 11.5009 12.6538 11.3147L10.9073 9.62456C10.5225 9.25217 9.89597 9.25217 9.51116 9.62456C9.12635 9.99696 9.12635 10.6033 9.51116 10.9757L11.2576 12.6658C11.45 12.852 11.45 13.1528 11.2576 13.339L9.51116 15.0291C9.12635 15.4015 9.12635 16.0078 9.51116 16.3802C9.89597 16.7526 10.5225 16.7526 10.9073 16.3802L12.6538 14.6901C12.8412 14.5039 13.157 14.4991 13.3494 14.6901Z"
      fill="#FFA064"
    />
    <path
      d="M18.8709 3.16493C19.2796 3.16493 19.6109 2.8443 19.6109 2.44878C19.6109 2.05326 19.2796 1.73264 18.8709 1.73264C18.4622 1.73264 18.1309 2.05326 18.1309 2.44878C18.1309 2.8443 18.4622 3.16493 18.8709 3.16493Z"
      fill="#FFA064"
    />
    <path
      d="M3.57693 4.11978C3.98563 4.11978 4.31695 3.79915 4.31695 3.40364C4.31695 3.00812 3.98563 2.68749 3.57693 2.68749C3.16823 2.68749 2.83691 3.00812 2.83691 3.40364C2.83691 3.79915 3.16823 4.11978 3.57693 4.11978Z"
      fill="#FFA064"
    />
    <path
      d="M3.57693 22.7396C3.98563 22.7396 4.31695 22.419 4.31695 22.0234C4.31695 21.6279 3.98563 21.3073 3.57693 21.3073C3.16823 21.3073 2.83691 21.6279 2.83691 22.0234C2.83691 22.419 3.16823 22.7396 3.57693 22.7396Z"
      fill="#FFA064"
    />
    <path
      d="M22.5705 4.11979C22.843 4.11979 23.0638 3.90603 23.0638 3.64236C23.0638 3.37868 22.843 3.16492 22.5705 3.16492C22.298 3.16492 22.0771 3.37868 22.0771 3.64236C22.0771 3.90603 22.298 4.11979 22.5705 4.11979Z"
      fill="#FFA064"
    />
    <path
      d="M23.5578 20.3524C23.8303 20.3524 24.0511 20.1387 24.0511 19.875C24.0511 19.6113 23.8303 19.3976 23.5578 19.3976C23.2853 19.3976 23.0645 19.6113 23.0645 19.875C23.0645 20.1387 23.2853 20.3524 23.5578 20.3524Z"
      fill="#FFA064"
    />
    <path
      d="M7.77069 3.64235C8.04316 3.64235 8.26403 3.4286 8.26403 3.16492C8.26403 2.90125 8.04316 2.68749 7.77069 2.68749C7.49822 2.68749 7.27734 2.90125 7.27734 3.16492C7.27734 3.4286 7.49822 3.64235 7.77069 3.64235Z"
      fill="#FFA064"
    />
    <path
      d="M20.1037 23.6944C20.3762 23.6944 20.597 23.4807 20.597 23.217C20.597 22.9533 20.3762 22.7396 20.1037 22.7396C19.8312 22.7396 19.6104 22.9533 19.6104 23.217C19.6104 23.4807 19.8312 23.6944 20.1037 23.6944Z"
      fill="#FFA064"
    />
    <path
      d="M8.26385 24.1719C8.53632 24.1719 8.7572 23.9581 8.7572 23.6944C8.7572 23.4308 8.53632 23.217 8.26385 23.217C7.99139 23.217 7.77051 23.4308 7.77051 23.6944C7.77051 23.9581 7.99139 24.1719 8.26385 24.1719Z"
      fill="#FFA064"
    />
    <path
      d="M12.7522 23.6992L3.55136 18.5573C3.39842 18.4713 3.30469 18.3138 3.30469 18.1419V7.85807C3.30469 7.68619 3.39842 7.52864 3.55136 7.4427L12.7522 2.30077C12.9052 2.21484 13.0927 2.21484 13.2456 2.30077L22.4465 7.4427C22.5994 7.52864 22.6931 7.68619 22.6931 7.85807V18.1419C22.6931 18.3138 22.5994 18.4713 22.4465 18.5573L13.2456 23.6992C13.0927 23.7852 12.9052 23.7852 12.7522 23.6992ZM4.29138 17.865L12.9989 22.7348L21.7065 17.8698V8.13498L12.9989 3.26518L4.29138 8.13498V17.865Z"
      fill="#FFA064"
    />
  </svg>
);
